import { type WatchQueryFetchPolicy } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { useBusinessIdPathParam } from 'lib/navigation/hooks/useBusinessIdPathParam/useBusinessIdPathParam'
import { skipTokenUnless } from 'lib/helpers/skipTokenUnless/skipTokenUnless'
import { BusinessHookDocument } from './useBusiness.graphql'

interface UseBusinessArgs {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useBusiness = ({ fetchPolicy }: UseBusinessArgs = {}) => {
  const businessId = useBusinessIdPathParam()
  const { data, previousData, loading } = useQuery(
    BusinessHookDocument,
    skipTokenUnless(businessId, {
      fetchPolicy,
      variables: { businessId },
    }),
  )

  return {
    loading,
    business: data?.business || previousData?.business || undefined,
  }
}
